import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import InventoryitemDashboard from '../InventoryitemDashboard';
import InventoryitemPageImpl from './InventoryitemPageImpl';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function InventoryitemPage() {
    const dispatch = useDispatch();
    const { inventoryitemList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':false}));
    },[]);

    return (
        < InventoryitemPageImpl />
    )

}